"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ga_1 = __importDefault(require("~/services/ga"));
const BaseLayerSelect_1 = __importDefault(require("~/view/BaseLayerSelect"));
const BaseControl_1 = __importDefault(require("./BaseControl"));
require("./BaseLayerSwitcher.scss");
;
/**
 * Contrôleur pour choisir le fond de carte.
 * S'inspire de OpenLayers.Control.LayerSwitcher
 */
class BaseLayerSwitcher extends BaseControl_1.default {
    /**
     * Constructor
     */
    constructor(options) {
        super(options);
        this.layers = options.layers;
        this.layerStates = [];
    }
    /**
     * Appelé lorsque le contrôleur est associé à la carte.
     * Met en place les listeners
     */
    setMap(map) {
        super.setMap(map);
        // Pour éviter de redessiner lors du chargement initial des layers, on
        // attend que la carte soit prête
        this.map.events.register('mapReady', this, function (event) {
            this.map.events.on({
                addlayer: this.redraw,
                //changelayer: this.redraw,
                removelayer: this.redraw,
                changebaselayer: this.redraw,
                scope: this,
            });
            this.redraw();
        });
    }
    /**
     * Détruit le contrôleur
     */
    destroy() {
        //should we destroy this.baseLayersSelect ?
        this.map.events.un({
            addlayer: this.redraw,
            changelayer: this.redraw,
            removelayer: this.redraw,
            changebaselayer: this.redraw,
            scope: this
        });
        super.destroy();
    }
    draw(px) {
        super.draw(px);
        this.keepEvents(this.div);
        // View
        this.baseLayerSelect = new BaseLayerSelect_1.default();
        this.baseLayerSelect.$el.on("submit", this.updateMap.bind(this));
        this.div.appendChild(this.baseLayerSelect.$el.get(0));
        return this.div;
    }
    /**
     * Method: checkRedraw
     * Checks if the layer state has changed since the last redraw() call.
     *
     * Returns:
     * {Boolean} The layer state changed since the last redraw() call.
     */
    checkRedraw() {
        var redraw = false;
        if (!this.layerStates.length ||
            (this.layers.length != this.layerStates.length)) {
            redraw = true;
        }
        else {
            for (var i = 0, len = this.layerStates.length; i < len; i++) {
                var layerState = this.layerStates[i];
                var layer = this.layers[i];
                if ((layerState.name != layer.name) ||
                    (layerState.inRange != layer.inRange) ||
                    (layerState.id != layer.id) ||
                    (layerState.visibility != layer.visibility)) {
                    redraw = true;
                    break;
                }
            }
        }
        return redraw;
    }
    /**
     * Method: redraw
     * Goes through and takes the current state of the Map and rebuilds the
     * control to display that state.
     */
    redraw() {
        //if the state hasn't changed since last redraw, no need
        // to do anything. Just return the existing div.
        if (!this.checkRedraw()) {
            return this.div;
        }
        // Save state -- for checking layer if the map state changed.
        // We save this before redrawing, because in the process of redrawing
        // we will trigger more visibility changes, and we want to not redraw
        // and enter an infinite loop.
        this.layerStates = this.layers.map(layer => ({
            name: layer.name,
            visibility: layer.visibility,
            inRange: layer.inRange,
            id: layer.id,
        }));
        // On actualise la View
        var layers = this.layers.slice();
        var selectedLayer = this.map.baseLayer;
        this.baseLayerSelect.redraw(layers, selectedLayer);
        return this.div;
    }
    /**
     * Makes the necessary calls to the Map object such that that the map's
     * visual state corresponds to what the user has selected in the control.
     */
    updateMap() {
        var layer = this.baseLayerSelect.selectedLayer;
        console.log("BaseLayerSelect", layer.permalinkId);
        if (!layer.map) {
            this.map.addLayer(layer); // Lazy loading
        }
        this.map.setBaseLayer(layer); // , false)
        ga_1.default.logEvent("Map:ChangeBaseLayer", { permalinkId: layer.permalinkId });
    }
}
exports.default = BaseLayerSwitcher;
Object.defineProperties(BaseLayerSwitcher.prototype, {
    CLASS_NAME: {
        value: "JGN.Control.BaseLayerSwitcher"
    }
});
